import { useCallback } from 'react';

import { useFeedbackStore } from '@/stores/feedbackStore';
import { FeedbackModal } from './FeedbackModal';

/**
 * The one Send feedback modal (YAR-482), mounted once in AppShell. The
 * drawer card and Settings › Help & About both open it through
 * `useFeedbackStore().openFeedback()`, so both get the same modal, the same
 * states and the same kept draft.
 *
 * On close, focus goes back to what was focused when it opened — for the
 * drawer entry that is the page's menu button, never the card inside the
 * closed drawer (YAR-484 AC 9).
 */
export function FeedbackModalHost() {
  const isOpen = useFeedbackStore((s) => s.isOpen);
  const closeFeedback = useFeedbackStore((s) => s.closeFeedback);

  const handleClose = useCallback(() => {
    const target = useFeedbackStore.getState().returnFocusTo;
    closeFeedback();
    if (target?.isConnected) target.focus();
  }, [closeFeedback]);

  return (
    <FeedbackModal
      open={isOpen}
      onClose={handleClose}
    />
  );
}
